import RequestForm from "../model/request-form"
import {RequestFormType} from "../const/const"
import {MandatoryFieldsIds} from "./get-mandatory-form-fields"
import DatetimeUtils from "../../../../core/gd/utils/datetime-utils"
import {prepareSubmissionData} from "./prepare-submission-data"

const debug = false
// const debug = "prepareFormDataForSharedViewSubmission"

export default function prepareFormDataForSharedViewSubmission(requestForm:RequestForm, result:any) {

    const task: any = {}

    const formFields:any    = []
    let fromName            = ''
    let fromEmail           = ''

    switch (requestForm.type) {
        case RequestFormType.FORM:
            fromName    = result[MandatoryFieldsIds.NAME]
            fromEmail   = result[MandatoryFieldsIds.EMAIL]
            break
    }

    // REQUIRED TITLE FIELD
    task.title = result[MandatoryFieldsIds.TITLE]

    prepareSubmissionData(requestForm, task, formFields, result)

    //hotfix (otherwise message 'scheduleDate: "unconverted data remains: T21:00:00.000Z"' is received
    if (task.scheduleDate) {
        task.scheduleDate = DatetimeUtils.momentToDate(DatetimeUtils.datetimeToMoment(task.scheduleDate))
    }

    if (task.startDate) task.startDate  = DatetimeUtils.momentToDate(DatetimeUtils.datetimeToMoment(task.startDate))
    if (task.endDate)   task.endDate    = DatetimeUtils.momentToDate(DatetimeUtils.datetimeToMoment(task.endDate))
    if (task.deadline)  task.deadline   = DatetimeUtils.momentToDate(DatetimeUtils.dateToMoment(task.deadline))

    return {
        task        : task,
        formFields  : formFields,
        fromName    : fromName,
        fromEmail   : fromEmail
    }
}